import React, { useLayoutEffect } from 'react';
import styled, { css } from 'styled-components';
import { mediaMixin, token, Flex } from '@zillow/constellation';

export const StyleWrapper = styled.div<{
    isLightboxBackgroundLocked: boolean;
    isCMS: boolean;
}>`
    margin: 0 auto;
    background-color: ${token('colors.gray200')};
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.35);
    position: relative;
    width: 700px;
    max-width: 100vw;
    max-height: ${({ isLightboxBackgroundLocked }) =>
        isLightboxBackgroundLocked ? 'calc(100vh - 140px)' : 'inherit'};
    overflow-y: auto;
    ${mediaMixin(
        'md_lte',
        ({ isLightboxBackgroundLocked }) => css`
            max-height: calc(100vh - 61px);
            max-height: ${isLightboxBackgroundLocked ? 'calc(100vh - 61px);' : 'inherit'};
            width: 700px;
            box-shadow: none;
            margin-top: 0;
        `
    )};
`;

const CenterWrapper = styled(Flex)<{
    isLightboxBackgroundLocked: boolean;
    isCMS: boolean;
}>`
    position: ${({ isLightboxBackgroundLocked, isCMS }) =>
        isLightboxBackgroundLocked || isCMS ? 'fixed' : 'absolute'};
    left: 0;
    right: 0;
    top: ${({ isCMS }) => (isCMS ? '80px' : '140px')};
    z-index: ${token('zIndices.modal')};
    margin: 0;
    ${mediaMixin(
        'md_lte',
        css`
            top: 61px;
        `
    )}
`;

interface ResponsiveLightboxProps {
    children: React.ReactElement | React.ReactElement[] | null;
    className?: string;
    isOpen?: boolean;
    isLightboxBackgroundLocked: boolean;
    isCMS?: boolean;
}

const ResponsiveLightbox = ({
    children = null,
    className,
    isOpen = true,
    isLightboxBackgroundLocked,
    isCMS = true,
}: ResponsiveLightboxProps) => {
    useLayoutEffect(() => {
        if (!isLightboxBackgroundLocked) {
            window.scrollTo(0, 0);
        }
    }, [isLightboxBackgroundLocked]);
    return isOpen ? (
        <CenterWrapper
            isLightboxBackgroundLocked={isLightboxBackgroundLocked}
            isCMS={isCMS}
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <StyleWrapper
                isLightboxBackgroundLocked={isLightboxBackgroundLocked}
                isCMS={isCMS}
                className={className}
            >
                {children}
            </StyleWrapper>
        </CenterWrapper>
    ) : null;
};

export default ResponsiveLightbox;
